module.exports = __webpack_public_path__ + "static/media/presale_supervision_system.81c36dad.png";